import React, { useState } from 'react';
import QRCodeStyling from 'qr-code-styling';

const DynamicQRCodeGenerator = () => {
  const [inputValue, setInputValue] = useState('');
  const [qrCodeColor, setQRCodeColor] = useState('#000000'); // Default color is black
  const [qrCodeBackgroundColor, setQRCodeBackgroundColor] = useState('#FFFFFF'); // Default background color is white
  const [qrCodeSize, setQRCodeSize] = useState(300); // Default size is 300

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleColorChange = (color, type) => {
    if (type === 'foreground') {
      setQRCodeColor(color);
    } else if (type === 'background') {
      setQRCodeBackgroundColor(color);
    }
  };

  const handleSizeChange = (e) => {
    setQRCodeSize(parseInt(e.target.value, 10));
  };

  const colorPalette = ['#000000', '#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FF00FF', '#00FFFF'];

  return (
    <div align="center">
      <h3> Dynamic QR Code Generator </h3>
    <input type="text" value={inputValue} onChange={handleInputChange} 
      placeholder="Enter the url text to generate QR" style={{  width: '400px'}}/>
      <br />
      
      <label htmlFor="sizeInput" style={{  width: '400px'}}>Enter QR Code Size:</label><input
        type="number"
        id="sizeInput"
        
        value={qrCodeSize}
        onChange={handleSizeChange}
        style={{  width: '100px'}}
      />
      <br />
      <label>Choose Foreground Color:</label>
      <div style={{ display: 'flex', gap: '5px', marginTop: '5px', justifyContent:'center'}}>
        {colorPalette.map((color, index) => (
          <div
            key={index}
            style={{ width: '20px', height: '20px', backgroundColor: color, cursor: 'pointer', justifyContent:'center' }}
            onClick={() => handleColorChange(color, 'foreground')}
          ></div>
        ))}
      </div>
      <br />
      <label>Choose Background Color:</label>
      <div style={{ display: 'flex', gap: '5px', marginTop: '5px', justifyContent:'center' }}>
        {colorPalette.map((color, index) => (
          <div
            key={index}
            style={{ width: '20px', height: '20px', backgroundColor: color, cursor: 'pointer' }}
            onClick={() => handleColorChange(color, 'background')}
          ></div>
        ))}
      </div>
      <br />
      <button onClick={generateQRCode}>Generate QR Code</button>
      <hr />
      <div id="qrcode"> </div>
    </div>
    
  );

  function generateQRCode() {
    const qrCode = new QRCodeStyling({
      width: qrCodeSize,
      height: qrCodeSize,
      data: inputValue,
      image: "/favicons/android-icon-36x36.png",
      dotsOptions: {
        color: qrCodeColor,
        type: "rounded"
      },
      backgroundOptions: {
        color: qrCodeBackgroundColor},
      
      imageOptions: {
          crossOrigin: "anonymous",
          
      }
    }
    );

    qrCode.append(document.getElementById('qrcode'));
  }
};

export default DynamicQRCodeGenerator;
